import { createAsyncThunk } from '@reduxjs/toolkit';
import factoryFilesApi from '../../../api/factoryFilesApi';

const REDUCER_NAME = 'factoryFiles';

export const GetFactoryFiles = createAsyncThunk(`${REDUCER_NAME}/getFactoryFiles`, async (_, thunkAPI) => {
  const res = await factoryFilesApi.get();
  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});
